import FormControl from "@material-ui/core/FormControl";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { Error as FieldError, Help, Label } from "../../templates";

const styles = (theme: Theme) =>
  createStyles({
    display: {
      color: theme.palette.text.primary,
      marginTop: theme.spacing(2),
      padding: "7px 0 9px",
    },
  });

export interface ReadOnlyFieldProps extends WithStyles<typeof styles> {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  label?: string;
  errors?: string[];
  help?: string;
  margin?: "dense" | "none" | "normal";
  children: any;
}

export const ReadOnlyFieldComponent = (props: ReadOnlyFieldProps) => {
  const { id, style, label, errors, help, margin, children, classes } = props;
  const className = classNames(classes.display, props.className);

  if ((errors || help) && !id) {
    throw Error("'id' is required for ReadOnlyField if 'errors' or 'help' is specified.");
  }

  return (
    <FormControl fullWidth={true} margin={margin ?? "normal"} style={style} error={(errors ?? []).length > 0}>
      {label && <Label fieldId={id} label={label} labelOnly={true} />}
      <div className={className}>{children}</div>
      {id ? (
        <>
          {errors && <FieldError fieldId={id} errors={errors} />}
          {help && <Help fieldId={id} help={help} />}
        </>
      ) : null}
    </FormControl>
  );
};

export const ReadOnlyField = withStyles(styles)(ReadOnlyFieldComponent);
